/**
 * Shared token → color resolver for Reader and VideoReader.
 *
 * Rules:
 *   - known / mastered / ignored  → inherit (no recolor; blend with text)
 *   - familiar                    → green  (#22C55E)
 *   - learning                    → orange (#F97316)
 *   - review                      → amber  (#F59E0B)
 *   - new                         → red    (#EF4444)   ← always red,
 *                                   regardless of accumulated strength
 *   - (no status at all)          → red, but darker if strength is high,
 *                                   just so words that somehow lost their
 *                                   status don't all look identical.
 *
 * Keep this pure and dependency-free so it can be imported by any UI.
 */
export function statusColor(status, strength = 0) {
  if (status === 'known' || status === 'mastered') return 'inherit';
  if (status === 'ignored') return 'inherit';
  if (status === 'familiar') return '#22C55E';
  if (status === 'learning') return '#F97316';
  if (status === 'review') return '#F59E0B';
  if (status === 'new') return '#EF4444';             // NEW → always red
  return strength >= 0.5 ? '#DC2626' : '#EF4444';     // unknown status → red
}
